import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchWithAuthBaseQuery } from '#shared/api';
import type { DataWithValidation } from '#shared/api';

import { validateMapSnapshotResponse } from './schemas';

import type { MapSnapshot } from './schemas';

/** A released bucket is reused when the operator scrubs back to an instant. */
const SNAPSHOT_KEEP_UNUSED_S = 600;

export const mapSnapshotPath = (asOfIso: string): string =>
  `api/map/snapshot?asOf=${encodeURIComponent(asOfIso)}`;

export const mapTimelineApi = createApi({
  reducerPath: 'mapTimelineApi',
  baseQuery: fetchWithAuthBaseQuery,
  keepUnusedDataFor: SNAPSHOT_KEEP_UNUSED_S,
  endpoints: build => ({
    getMapSnapshot: build.query<DataWithValidation<MapSnapshot>, string>({
      // `queryFn` rather than `transformResponse`, so a body that fails
      // validation becomes a query error instead of cached data.
      queryFn: async (asOfIso, api, extraOptions, baseQuery) => {
        const result = await baseQuery(mapSnapshotPath(asOfIso));
        if (result.error) {
          return { error: result.error };
        }
        const validation = validateMapSnapshotResponse(result.data);
        if (!validation.ok) {
          return {
            error: { error: validation.message, name: 'MapSnapshotShapeError' },
          };
        }
        return { data: validation.value };
      },
    }),
  }),
});

export const { useGetMapSnapshotQuery } = mapTimelineApi;
